import { extendObservable, action } from 'mobx';
import FetchService from '../../../core/services/FetchService';
import FormService from '../../../core/services/FormService';
import NotificationService from '../../../core/services/NotificationService';
import { isRequired } from '../../../core/validations';
import { browserHistory } from 'react-router';

export default class VocabularyThemeFormService {
  fetch = new FetchService();
  submit = new FetchService();
  form = new FormService();

  constructor() {
    extendObservable(this, {
      vocabularyThemeId: null,
    });
    this.form.validations = {
      name: [isRequired],
    };
  }

  handleLoad = action((vocabularyThemeId) => {
    this.form.reset();
    if (vocabularyThemeId) {
      this.fetch
        .fetch({
          apiVersion: 'v3',
          url: `/vocabulary-themes/${vocabularyThemeId}`,
        })
        .then(() => {
          if (this.fetch.data) {
            this.form.setInitialValues(this.fetch.data);
            this.form.validations = {
              name: [isRequired],
            };
          }
        });
    } else {
      this.form.setInitialValues({});
      this.form.validations = {
        name: [isRequired],
      };
    }
  });

  handleSubmit = action(() => {
    this.form.submitted = true;
    if (this.form.errors) {
      NotificationService.addNotification('Fill the required fields', 'error');
      return;
    }
    const vocabularyThemeId = this.form.getValue('id');
    this.submit
      .fetch({
        apiVersion: 'v3',
        method: vocabularyThemeId ? 'put' : 'post',
        url: vocabularyThemeId ? `/vocabulary-themes/${vocabularyThemeId}` : '/vocabulary-themes',
        body: { ...this.form.getValues() },
      })
      .then(() => {
        if (this.submit.data) {
          this.form.reset();

          NotificationService.addNotification(
            `Vocabulary theme ${vocabularyThemeId ? 'updated' : 'created'} successfully.`,
            'success'
          );
          browserHistory.replace(`/vocabulary-themes`);
        }
        if (this.submit.error) {
          NotificationService.addNotification(
            `Error ${vocabularyThemeId ? 'updating' : 'creating'} vocabulary theme.`,
            'error'
          );
        }
      });
  });
}
